import React from 'react'

export default function getNumberFormat(lang, options) {
    if (lang === 'es') lang = 'de'
    return new Intl.NumberFormat(lang, options)
}
